import React, {Fragment} from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import Translator from "Languages/Utility/Translator";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import HistoriesTable from "./components/HistoriesTable";

function Histories() {

    return (
        <>
            <Fragment>
                <div className="d-flex justify-content-between my-2">
                    <PageTitle title={<Translator id="history" />} />
                </div>
                <MuiPaper className="mb-5">
                    <HistoriesTable />
                </MuiPaper>
            </Fragment>
        </>
    );
}

export default Histories;
